import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { getSetting } from '../../helpers/Settings';

import HelpIcon from '../HelpIcon';
import LoadingSmall from '../LoadingSmall';

const UploadFileAccessGroups = ({
  groups,
  groupsLoading,
  selectedGroups,
  handleSwitchGroup,
}) => {
  const intl = useIntl();

  return (
    <FormGroup>
      <Label>
        {intl.formatMessage({ defaultMessage: 'Assign access to files and Collections to Teams' })}
        {getSetting('cs1') && (
          <HelpIcon>
            {intl.formatMessage({
              defaultMessage: `For all shows and portraits, change the access 
                toggles to:{br} Communications - request and ESPN - request`,
            }, { br: <br /> })}
          </HelpIcon>
        )}
      </Label>
      {groupsLoading ? (
        <LoadingSmall />
      ) : (
        <ListGroup flush className="switch-list group-permissions-list files-permissions-list">
          {groups.map(g => (
            <ListGroupItem key={g.uuid}>
              <Label for={`switchGroup-${g.uuid}`} className="switch">
                <div className="switch-details">
                  <span>
                    {g.name}
                  </span>
                </div>
                <div className="switch-control input-inner">
                  <Input
                    type="checkbox"
                    name="groupUploadFile"
                    id={`switchGroup-${g.uuid}`}
                    value="true"
                    checked={selectedGroups.includes(g.uuid)}
                    onChange={() => { handleSwitchGroup(g.uuid); }}
                  />
                  <i />
                </div>
              </Label>
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
    </FormGroup>
  );
};

UploadFileAccessGroups.propTypes = {
  groups: PropTypes.array.isRequired,
  groupsLoading: PropTypes.bool.isRequired,
  selectedGroups: PropTypes.array.isRequired,
  handleSwitchGroup: PropTypes.func.isRequired,
};

export default UploadFileAccessGroups;
